import { render, staticRenderFns } from "./GiftyIcon.vue?vue&type=template&id=1a7babb3&scoped=true&"
import script from "./GiftyIcon.vue?vue&type=script&lang=js&"
export * from "./GiftyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7babb3",
  null
  
)

export default component.exports